import CryptoJS from 'crypto-js';
import api, { API_VERSION, ValidateAxiosError } from '@/modules/api.service';
import { AuthToken, SingleInputDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { PERMISSOES_USUARIO, TOKEN_KEY } from '@/shared/constants/strings';
import { RoleLevelDto } from '../../papeis/role-level.dto';
import { SECRET_KEY_PERMISSOES } from '@/shared/constants/strings';

/**
 * Efetua login no sistema.
 * @param usuario Nome de usuário
 * @param senha Senha.
 * @returns Estado.
 */
export async function Logar(usuario: string, senha: string) {
  return api
    .post(
      `${Endpoints.AUTH}`,
      {
        username: usuario,
        password: senha,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Version: API_VERSION,
        },
      },
    )
    .then((res) => {
      setLoginTokenOnStorage((res.data as AuthToken).value);
      return res.data;
    })
    .catch((error) => {
      return ValidateAxiosError(error, error.response.data.message);
    });
}

export async function LogarComGoogle() {
  return api
    .get('auth/google', { headers: { 'Content-Type': 'application/json' } })
    .then((res) => {
      setLoginTokenOnStorage(res.data);
      return res.data;
    })
    .catch((error) => {
      return ValidateAxiosError(error, error.response.data.message);
    });
}

/**
 * Troca a senha do usuário.
 * @param senha nova senha.
 * @param codigorecuperacao código de recuperação.
 * @returns void.
 */
export async function TrocarSenha(senha: string, codigorecuperacao: string) {
  return api
    .patch(
      Endpoints.AUTH + '/trocarsenha',
      { senha: senha, codigorecuperacao: codigorecuperacao },
      { headers: { 'Content-Type': 'application/json' } },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return ValidateAxiosError(error, 'Falha ao trocar senha.');
    });
}

export async function requestPasswordRecoveryCode(email: string) {
  const input: SingleInputDto = { input: email }

  return api
    .post(Endpoints.AUTH + '/recuperar', input, { headers: { 'Content-Type': 'application/json' } })
    .then((res) => { return res })
    .catch((error) => { return error });
}

/**
 * Sai do sistema.
 */
export function Deslogar() {
  localStorage.clear();
}

/**
 * Carrega as permissões do token.
 * @returns
 */
export function CarregarPermissoes() {
  try {

    const bytes = CryptoJS.AES.decrypt(localStorage.getItem(PERMISSOES_USUARIO) as string, SECRET_KEY_PERMISSOES);
    if (bytes) {

      const permissoes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) as RoleLevelDto[];
      return permissoes;
    }
    return [];
  } catch (error) {
    return [];
  }
}

/**
 * Valida se o usuário tem determinada permissão.
 * @param disponiveis Lista com as permissões que o usuário possui.
 * @param necessarias Permissões requisitadas pela interface.
 * @returns True or False.
 */
export function ValidarPermissao(disponiveis: RoleLevelDto[], necessarias: RoleLevelDto[]) {
  return necessarias.every((necessaria) => {
    const disponivel = disponiveis.find(d => Number(d.role) === Number(necessaria.role) && Number(d.level) >= Number(necessaria.level));
    return disponivel;
  });
}


/**
 * Define o token no sistema.
 * @param token Token com permissões.
 */
export function setLoginTokenOnStorage(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

/**
 * Busca o token de login.
 * @returns O token de login.
 */
export function getLoginTokenFromStorage() {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * Verifica se está logado.
 * @returns true or false.
 */
export function isLogedIn() {
  const token = getLoginTokenFromStorage();
  return typeof token !== 'undefined' && token != null;
}

/**
 * Permissões do usuário.
 * @param encrypted Permissões do usuário
 */
export function SetPermissoes(encrypted: string) {
  localStorage.setItem(PERMISSOES_USUARIO, encrypted);
}
